
const VERSION = {
  SHA1:'3723e8a3a8f4e4be785e8c6ca7acbd132e9787da',
  VERSION:2345,
  BRANCH:'main',
  PROJECT:'ostium-ne'
}
export default VERSION;
